import {
  IMG_LEVEL_2_FORGROUND,
  IMG_LEVEL_2_BACKGROUND,
  IMG_LEVEL_2_BACKGROUND_2,
  ENEMY_FACES_LEFT,
} from '../constants';

export default {
  forground: IMG_LEVEL_2_FORGROUND,
  background1: IMG_LEVEL_2_BACKGROUND,
  background2: IMG_LEVEL_2_BACKGROUND_2,
  objects: [
    [3772, 360, 350, 35],
    [2322, 538, 352, 90],
    [0, 0, 5, 2260],
    [667, 626, 64, 28],
    [0, 387, 545, 76],
    [0, 2255, 6150, 5],
    [6139, 0, 5, 2255],
    [0, 0, 6144, 5],
    [0, 745, 304, 73],
    [306, 820, 698, 216],
    [0, 1553, 648, 230],
    [0, 1764, 174, 457],
    [79, 2223, 1700, 22],
    [1416, 1263, 771, 30],
    [1767, 1292, 60, 940],
    [1830, 1524, 370, 724],
    [2200, 2044, 3210, 206],
    [2775, 1870, 82, 100],
    [3397, 885, 151, 1200],
    [3173, 1394, 852, 101],
    [3181, 797, 852, 101],
    [4151, 1846, 225, 200],
    [1923, 799, 852, 101],
    [2020, 0, 308, 805],
    [1680, 0, 326, 431],
    [4743, 1381, 852, 101],
    [5218, 1448, 151, 750],
    [5375, 2147, 800, 100],
    [5776, 460, 380, 310],
    [4079, 0, 772, 452],
    [5494, 740, 321, 28],
    [4111, 1572, 167, 19],
    [4197, 1029, 167, 19],
    [2518, 1638, 130, 12],
    [2354, 1358, 130, 12],
    [2197, 1682, 45, 31],
    [2197, 1855, 45, 31],
  ],
  actionItems: [
    {
      type: 'DOOR',
      x: 0,
      y: 553,
      w: 192,
      h: 192,
      spriteCount: 0,
      maxSpriteCount: 7,
      img: 'DOOR',
    },
    {
      type: 'horisontal elevator',
      x: 2400,
      y: 420,
      w: 196,
      h: 36,
      speed: 4,
      startX: 2400,
      maxX: 3560,
      spriteCount: 0,
      maxSpriteCount: 3,
      img: 'ELEVATOR',
    },
    {
      type: 'horisontal elevator',
      x: 5810,
      y: 1150,
      w: 196,
      h: 36,
      speed: 4,
      startX: 4200,
      maxX: 5830,
      spriteCount: 0,
      maxSpriteCount: 3,
      img: 'ELEVATOR',
    },
    {
      type: 'horisontal elevator',
      x: 1322,
      y: 829,
      w: 196,
      h: 36,
      speed: 4,
      startX: 1322,
      maxX: 1729,
      spriteCount: 0,
      maxSpriteCount: 3,
      img: 'ELEVATOR',
    },
    {
      type: 'horisontal elevator',
      x: 4060,
      y: 790,
      w: 196,
      h: 36,
      speed: 6,
      startX: 4060,
      maxX: 5030,
      spriteCount: 0,
      maxSpriteCount: 3,
      img: 'ELEVATOR',
    },
    {
      type: 'vertical elevator',
      x: 4535,
      y: 1600,
      w: 196,
      h: 36,
      speed: 6,
      startY: 1382,
      maxY: 2000,
      spriteCount: 0,
      maxSpriteCount: 3,
      img: 'ELEVATOR',
    },
    {
      type: 'vertical elevator',
      x: 2922,
      y: 1870,
      w: 196,
      h: 36,
      speed: 6,
      startY: 804,
      maxY: 1900,
      spriteCount: 0,
      maxSpriteCount: 3,
      img: 'ELEVATOR',
    },
    {
      type: 'vertical elevator',
      x: 5666,
      y: 1284,
      w: 196,
      h: 36,
      speed: 6,
      startY: 1284,
      maxY: 2000,
      spriteCount: 0,
      maxSpriteCount: 3,
      img: 'ELEVATOR',
    },
    {
      type: 'vertical elevator',
      x: 657,
      y: 2100,
      w: 196,
      h: 36,
      speed: 6,
      startY: 1550,
      maxY: 2170,
      spriteCount: 0,
      maxSpriteCount: 3,
      img: 'ELEVATOR',
    },
    {
      type: 'vertical elevator',
      x: 1020,
      y: 820,
      w: 196,
      h: 36,
      speed: 8,
      startY: 820,
      maxY: 2170,
      spriteCount: 0,
      maxSpriteCount: 3,
      img: 'ELEVATOR',
    },
    {
      type: 'DOOR',
      x: 5889,
      y: 269,
      w: 192,
      h: 192,
      spriteCount: 0,
      maxSpriteCount: 7,
      img: 'DOOR',
    },
  ],
  messages: [],
  explosions: [],
  shots: [], // projectiles
  hits: [],
  items: [
    {
      type: 'WATCHER',
      x: 5900,
      y: 1950,
      w: 75,
      h: 75,
      status: true,
    },
    {
      type: 'LEVEL',
      mode: 'MODE_PLAY_GAME',
      next: 'sc1',
      startX: 2600,
      startY: 2550,
      x: 0,
      y: 553,
      w: 192,
      h: 192,
      status: true,
    },
    {
      type: 'LEVEL',
      mode: 'MODE_SC3',
      next: 'sc3',
      startX: 295,
      startY: 2740,
      x: 5889,
      y: 269,
      w: 192,
      h: 192,
      status: true,
    },
    {
      type: 'MEDICIN',
      x: 2410,
      y: 470,
      w: 75,
      h: 75,
      status: true,
    },
    {
      type: 'MEDICIN',
      x: 150,
      y: 330,
      w: 75,
      h: 75,
      status: true,
    },
    {
      type: 'MEDICIN',
      x: 3730,
      y: 1230,
      w: 75,
      h: 75,
      status: true,
    },
    {
      type: 'AMMO',
      x: 5500,
      y: 2040,
      w: 75,
      h: 75,
      status: true,
    },
    {
      type: 'AMMO',
      x: 5700,
      y: 2040,
      w: 75,
      h: 75,
      status: true,
    },
    {
      type: 'AMMO',
      x: 3900,
      y: 275,
      w: 75,
      h: 75,
      status: true,
    },
    {
      type: 'AMMO',
      x: 740,
      y: 720,
      w: 75,
      h: 75,
      status: true,
    },
    {
      type: 'AMMO',
      x: 720,
      y: 720,
      w: 75,
      h: 75,
      status: true,
    },
    {
      type: 'AMMO',
      x: 2420,
      y: 720,
      w: 75,
      h: 75,
      status: true,
    },
    {
      type: 'AMMO',
      x: 1550,
      y: 2189,
      w: 75,
      h: 75,
      status: true,
    },
    {
      type: 'AMMO',
      x: 1450,
      y: 2189,
      w: 75,
      h: 75,
      status: true,
    },
    {
      type: 'AMMO',
      x: 3700,
      y: 1850,
      w: 75,
      h: 75,
      status: true,
    },
    {
      type: 'MEDICIN',
      x: 180,
      y: 1430,
      w: 75,
      h: 75,
      status: true,
    },
    {
      type: 'MEDICIN',
      x: 1939,
      y: 750,
      w: 75,
      h: 75,
      status: true,
    },
  ],
  enemies: [
    {
      type: 'TYPE_1',
      x: 130,
      y: 340,
      status: true,
      hp: 3,
      w: 99,
      h: 111,
      jumping: false,
      spriteCount: 0,
      speed: -3,
      grounded: false,
      velX: 0,
      velY: 10,
      state: 'LEFT',
      faces: ENEMY_FACES_LEFT,
    },
    {
      type: 'TYPE_1',
      x: 330,
      y: 2080,
      status: true,
      hp: 3,
      w: 99,
      h: 111,
      jumping: false,
      spriteCount: 0,
      speed: -3,
      grounded: false,
      velX: 0,
      velY: 10,
      state: 'LEFT',
      faces: ENEMY_FACES_LEFT,
    },
    {
      type: 'TYPE_1',
      x: 130,
      y: 1388,
      status: true,
      hp: 3,
      w: 99,
      h: 111,
      jumping: false,
      spriteCount: 0,
      speed: -3,
      grounded: false,
      velX: 0,
      velY: 10,
      state: 'LEFT',
      faces: ENEMY_FACES_LEFT,
    },
    {
      type: 'TYPE_1',
      x: 5550,
      y: 2020,
      status: true,
      hp: 2,
      shotInterval: 0,
      w: 99,
      h: 111,
      jumping: false,
      spriteCount: 0,
      speed: -4,
      grounded: false,
      velX: 0,
      velY: 10,
      state: 'LEFT',
      faces: ENEMY_FACES_LEFT,
    },
    {
      type: 'TYPE_1',
      x: 2450,
      y: 1800,
      status: true,
      hp: 2,
      shotInterval: 0,
      w: 99,
      h: 111,
      jumping: false,
      spriteCount: 0,
      speed: -4,
      grounded: false,
      velX: 0,
      velY: 10,
      state: 'LEFT',
      faces: ENEMY_FACES_LEFT,
    },
    {
      type: 'TYPE_1',
      x: 4600,
      y: 1830,
      status: true,
      hp: 2,
      shotInterval: 0,
      w: 99,
      h: 111,
      jumping: false,
      spriteCount: 0,
      speed: -4,
      grounded: false,
      velX: 0,
      velY: 10,
      state: 'LEFT',
      faces: ENEMY_FACES_LEFT,
    },
    {
      type: 'TYPE_2',
      x: 4800,
      y: 1940,
      status: true,
      hp: 3,
      shotInterval: 0,
      w: 142,
      h: 127,
      jumping: false,
      spriteCount: 0,
      speed: -4,
      grounded: false,
      velX: 0,
      velY: 10,
      state: 'LEFT',
      faces: ENEMY_FACES_LEFT,
    },
    {
      type: 'TYPE_2',
      x: 4850,
      y: 1240,
      status: true,
      hp: 3,
      shotInterval: 0,
      w: 142,
      h: 127,
      jumping: false,
      spriteCount: 0,
      speed: -4,
      grounded: false,
      velX: 0,
      velY: 10,
      state: 'LEFT',
      faces: ENEMY_FACES_LEFT,
    },
    {
      type: 'TYPE_2',
      x: 715,
      y: 2080,
      status: true,
      hp: 3,
      shotInterval: 0,
      w: 142,
      h: 127,
      jumping: false,
      spriteCount: 0,
      speed: -4,
      grounded: false,
      velX: 0,
      velY: 10,
      state: 'LEFT',
      faces: ENEMY_FACES_LEFT,
    },
    {
      type: 'TYPE_2',
      x: 3222,
      y: 640,
      hp: 3,
      status: true,
      shotInterval: 0,
      w: 142,
      h: 127,
      jumping: false,
      spriteCount: 0,
      speed: -4,
      grounded: false,
      velX: 0,
      velY: 10,
      state: 'LEFT',
      faces: ENEMY_FACES_LEFT,
    },
  ],
  areas: [],
};
